import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
          "Problem Solver",
          "Software Developer",
          "End-to-End Developer",
          "Tech Explorer",
          "CS Learner",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 35,
        delay: 35,
      }}
    />
  );
}

export default Type;
